'use client';
import { useState } from 'react';
import { animated, config, useSpring } from '@react-spring/web';
import Typewriter from 'typewriter-effect';

export const ChatBubbleExample = () => {
  const [score, setScore] = useState(0);

  const { number } = useSpring({
    from: { number: 0 },
    number: score,
    config: config.molasses,
  });

  return (
    <div className=" m-auto ml-4 lg:ml-auto  pt-12 flex items-center justify-center">
      <div
        className="animate-float"
        style={{
          perspective: 500,
        }}
      >
        <div
          className="mr-4 md:mr-0 lg:w-auto flex flex-col shadow-xl p-8 bg-white border-2 border-gray-100 relative "
          style={{
            width: 'min(90vw, 390px)',

            minHeight: 210,
            borderRadius: 80,
            borderBottomRightRadius: 10,
            borderBottom: 'none',
            transform: 'rotateX(3deg) rotateY(5deg)',
          }}
        >
          <Typewriter
            options={{
              skipAddStyles: true,
              loop: true,
              delay: 40,
              deleteSpeed: 1,
              cursor: '',
            }}
            onInit={(typewriter) => {
              typewriter
                .callFunction(() => {
                  setScore(0);
                })
                .typeString(
                  `<p class=" xl:text-lg font-medium text-gray-400 z-10 ">Hi, I'm <span class="text-red-400 font-semibold">Christopher</span>, founder of Moderation API. </p>`,
                )
                .callFunction(() => {
                  setScore(60);
                })
                .pauseFor(1000)
                .typeString(
                  `<p class=" xl:text-lg font-medium text-gray-400 z-10 ">If you have questions, please message us at <span class="text-red-400 font-semibold">info@moderationapi.com</span>.</p>`,
                )
                .callFunction(() => {
                  setScore(99);
                })
                .pauseFor(2500)
                .deleteAll(0)
                .start();
            }}
          />

          <div className="flex-1" />
          <div className="flex   items-center justify-end mt-2 -mb-1">
            <p className="text-gray-400 font-medium text-sm">
              Contains PII {/* @ts-ignore */}
              <animated.span className="w-8 inline-block">
                {number.to((n) => n.toFixed(1))}
              </animated.span>
              %
            </p>
            <div
              className={
                'transition-all w-4 h-4 rounded-full  ml-2 animate-pulse ' +
                (score > 0 && score < 80
                  ? 'bg-yellow-400'
                  : score >= 80
                    ? 'bg-red-400'
                    : 'bg-green-400')
              }
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
};
